export default {
  redCardTitle: {
    background: 'red',
  },
  blueCardTitle: {
    background: 'rgb(3, 169, 244)',
  },
  greenCardTitle: {
    background: 'green',
  },
  summaryCharts: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  card: {
    margin: 10,
    flex: 1,
  },
  card2: {
    margin: 10,
    flex: 2,
  },
  stats: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  title: {
    justifyContent: 'space-between',
    display: 'flex',
  },
  stageIcon: {
    height: 40,
    width: 40,
  },
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
};



// WEBPACK FOOTER //
// ./src/components/Reports/JobReport/styles.js